<template>
  <div class="md-layout text-center">
    <div class="md-layout-item md-size-50 logo-main md-small-size-100">
      <img :src="logo" alt="">
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(projectLogin)">
      <login-card>
        <div slot="login-header" class="login-header-wrapper">
          <h3 class="page-title">Log Into Project Portal</h3>
        </div>
        <div slot="inputs">
        <ValidationProvider
          name="email"
          rules="required|email"
          v-slot="{ passed, failed }"
        >
        <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
          <md-icon>email</md-icon>
          <label>Email</label>
          <md-input v-model="email" type="email"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="failed">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="passed">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </ValidationProvider>

      <ValidationProvider
        name="password"
        rules="required"
        v-slot="{ passed, failed }"
      >
        <md-field class="md-form-group" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
          <md-icon>lock_outline</md-icon>
          <label>Password</label>
          <md-input v-model="password" type="password"></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="failed">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="passed">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </ValidationProvider>
      <div class="errors" v-if="!inviteResent">
        {{errors}}
        <p v-if="pendingLink" v-on:click="resendLink" class="errlink">If you cannot find the invitation email in your inbox, click here to get it resent.</p>
      </div>
      <div v-if="inviteResent">
        A new invitation has been sent to {{email}}, please check it again
      </div>
    </div>
        <md-button
          type="submit"
          slot="footer"
          class="md-simple md-success md-lg submit"
        >
          Log into Project Portal
        </md-button>
        <p v-if="failed">Problems with login. Please check that you have confirmed your email and have typed your password correctly.</p>
      </login-card>
      </form>
    </ValidationObserver>

  <div style="padding-top: 10px">

   <a href='/#/sendreset' style='font-weight:700; color: rgb(0, 88, 130)'>Reset Password</a><br>
   <a href='/#/create' style='font-weight:700; color: #c81517'>
    <md-button
            type="button"
            slot="footer"
            class="md-lg create-account"
          >
      CREATE YOUR FREE SAFECORE ACCOUNT 
    </md-button>
   </a>
  </div>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import api from "@/api"

extend("email", email);
extend("required", required);

export default {
  components: {
    LoginCard
  },
  props: {
    logo: {
      type: String,
      default: "./img/mainscs_logo.png"
    },
  },
  data() {
    return {
      email: "",
      password: "",
      isAdmin: false,
      errors: "",
      failed: false,
      pendingLink: false,
      inviteResent: false,
      currentPage: {
        loginLink: "#/projectportal",
        otherLogin: "#/adminlogin"
      },
    };
  },
  created(){
    this.$store
      .dispatch("signOut", {})
      .then(() => {
        console.log('confirmed no extra user in local')
      })
  },
  methods: {
    resendLink(){
      var u = {
        email: this.email
      }
      console.log('in resend')
      api.resendInvite(u).then((response) => {
        console.log(response)
        this.inviteResent = true;
      })
    },
    projectLogin() {
      this.inviteResent = false;
      this.pendingLink = false;
      this.$store
        .dispatch("signIn", {
          user: {
            email: this.email,
            password: this.password
          }
        })
        .then(response => {
          // console.log(response);
          console.log('here in response ready to redirect correctly')
          this.errors = {};
          if (this.$store.getters.company){
      	    if (this.$route.query.redirect) {
      	      this.$router.push(this.$route.query.redirect);
      	    } else {
              this.$router.push("projectportal");
      	    }
          } else {
            this.$router.push("projectportal");
            // this.$router.push("setcompany");
          }
        })
        .catch(errors => {
          // console.log('here')
          // console.log(errors)
          this.failed = true;
          this.errors = errors.data;
          if (this.errors.toLowerCase().includes('pending')) {this.pendingLink = true}
          // console.log(this.errors)
        });
    }
  }
};
</script>

<style lang="scss">
  .errors {
    color: red;
    text-transform: capitalize;
  }
  .errlink {
    text-decoration: underline;
    cursor: pointer;
  }
  .create-account{
    background-color: #c81517 !important;
    color: white;
  }
</style>
